import { useState } from 'react';
import { Save, Loader2, Check } from 'lucide-react';

interface SaveButtonProps {
    onClick: () => Promise<void>;
    defaultLabel?: string;
    successLabel?: string;
    disabled?: boolean;
    className?: string;
}

export const SaveButton = ({
    onClick,
    defaultLabel = 'Save Changes',
    successLabel = 'Saved!',
    disabled = false,
    className = ''
}: SaveButtonProps) => {
    const [status, setStatus] = useState<'idle' | 'loading' | 'success'>('idle');

    const handleClick = async () => {
        if (status !== 'idle') return;

        setStatus('loading');
        try {
            await onClick();
            setStatus('success');
            setTimeout(() => setStatus('idle'), 3000);
        } catch (error) {
            console.error('Save failed:', error);
            setStatus('idle');
            // Error handling usually managed by parent via alert/toast for now, 
            // but we reset status so they can try again.
        }
    };

    const isSuccess = status === 'success';
    const isLoading = status === 'loading';

    return (
        <button
            onClick={handleClick}
            disabled={disabled || isLoading || isSuccess}
            className={`fd-btn ${isSuccess ? 'fd-btn-secondary !text-success' : 'fd-btn-primary'} ${className}`}
        >
            {isLoading ? (
                <Loader2 className="w-4 h-4 animate-spin" />
            ) : isSuccess ? (
                <Check className="w-4 h-4" />
            ) : (
                <Save className="w-4 h-4" />
            )}
            {isSuccess ? successLabel : defaultLabel}
        </button>
    );
};
